export const guStates = [{ value: 'GU', label: 'GU' }]
